import { render, staticRenderFns } from "./TravelersDependent.vue?vue&type=template&id=77979ddc&scoped=true&"
import script from "./TravelersDependent.vue?vue&type=script&lang=js&"
export * from "./TravelersDependent.vue?vue&type=script&lang=js&"
import style0 from "./TravelersDependent.vue?vue&type=style&index=0&id=77979ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77979ddc",
  null
  
)

export default component.exports